module.exports = __webpack_public_path__ + "media/images/emblems/Uetendorf-coat_of_arms-fb21d2f97bf4531aee74c9aaba84ba36.svg";